import { render, staticRenderFns } from "./testQuestionManagement.vue?vue&type=template&id=61e39768&scoped=true&"
import script from "./testQuestionManagement.vue?vue&type=script&lang=js&"
export * from "./testQuestionManagement.vue?vue&type=script&lang=js&"
import style0 from "./testQuestionManagement.vue?vue&type=style&index=0&id=61e39768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e39768",
  null
  
)

export default component.exports